var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiaCertificate(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "24px",
    viewBox: "0 0 18 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "103509_text_document_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-D---SFY---PDP",
    transform: "translate(-1043.000000, -1400.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document_x5F_text",
    transform: "translate(1043.000000, 1400.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 17 4 16 10 16 10 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 11 4 10 14 10 14 11"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "4 14 4 13 14 13 14 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8105,0 L0,0 L0,24 L18,24 L18,4.188 L13.8105,0 Z M13.4985,1.80975 L16.1895,4.5 L13.4985,4.5 L13.4985,1.80975 L13.4985,1.80975 Z M1.5,22.5 L1.5,1.4985 L12,1.4985 L12,5.99925 L16.5,5.99925 L16.5,22.5 L1.5,22.5 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiaCertificate);
export default __webpack_public_path__ + "static/media/gia_certificate.089ee52754b8404f08aa24e51c943f79.svg";
export { ForwardRef as ReactComponent };